export const workspaceCommonMessagesEn = {
  // Sidebar section
  'workspaceCommon.sidebar.viewOptions.title': 'View options',
  'workspaceCommon.sidebar.viewOptions.collapseButtonLabel': 'Hide details',
  'workspaceCommon.sidebar.viewOptions.expandButtonLabel': 'Show details',

  // Group by section
  'workspaceCommon.sidebar.viewOptions.groupBy.title': 'Group by',
  'workspaceCommon.sidebar.viewOptions.groupBy.none': 'None',
  'workspaceCommon.sidebar.viewOptions.groupBy.type': 'Type',
  'workspaceCommon.sidebar.viewOptions.groupBy.date': 'Date',

  // Sort by section
  'workspaceCommon.sidebar.viewOptions.sortBy.title': 'Sort by',
  'workspaceCommon.sidebar.viewOptions.sortBy.ascending': 'Ascending',
  'workspaceCommon.sidebar.viewOptions.sortBy.descending': 'Descending',

  // Filter by section
  'workspaceCommon.sidebar.viewOptions.filterBy.title': 'Filter by',
  'workspaceCommon.sidebar.viewOptions.filterBy.label': 'Note type',

  'workspaceCommon.content.dropdown.project.label': 'Project',
  'workspaceCommon.content.dropdown.project.placeholder': 'Select project',
  'workspaceCommon.content.dropdown.batch.label': 'Batch',
  'workspaceCommon.content.dropdown.batch.placeholder': 'Select batch',

  'workspaceCommon.content.table.noProjectSelected.title': 'No project selected',
  'workspaceCommon.content.table.noBatchSelected.title': 'No batch selected',
  'workspaceCommon.content.table.noProjectSelected.description':
    'Select a project and a batch to view encounters.',
  'workspaceCommon.content.table.noProjectAssigned.title': 'No project assigned',
  'workspaceCommon.content.table.noProjectAssigned.description':
    'You are not assigned to any projects.',
  'workspaceCommon.content.table.noProjectsAvailable.title': 'No projects available',
  'workspaceCommon.content.table.noProjectsAvailable.description':
    'There are no projects created yet.',
  'workspaceCommon.content.table.noBatchesAvailable.title': 'No batches available',
  'workspaceCommon.content.table.noBatchesAvailable.description':
    'There are no batches available for the selected project.',

  'workspaceCommon.content.table.encounterType.annotation': 'Annotation',
  'workspaceCommon.content.table.encounterType.observation': 'Observation',
  'workspaceCommon.content.table.encounterType.inpatient': 'Inpatient',
  'workspaceCommon.content.table.encounterType.ed': 'ED',
  'workspaceCommon.content.table.status.pending': 'Pending annotation',
  'workspaceCommon.content.table.status.finalized': 'Finalized',
  'workspaceCommon.content.table.status.draft': 'Draft',
  'workspaceCommon.content.table.status.inprogress': 'In progress',
  'workspaceCommon.content.table.status.completed': 'Completed',
  'workspaceCommon.content.table.status.active': 'Active',

  'workspaceCommon.noNoteSelected.title': 'No note selected',
  'workspaceCommon.noNoteSelected.description': 'Select a note to get started',
  'workspaceCommon.noteSection.title': 'Note summary',
  'workspaceCommon.noteSection.characters': 'characters',
  'workspaceCommon.annotations.expandAllButton': 'Expand all',
  'workspaceCommon.annotations.collapseAllButton': 'Collapse all',

  // Annotation config (shared between annotation and supervisor)
  'workspaceCommon.annotationConfig.title': 'Annotations',
  'workspaceCommon.annotationConfig.conceptCard.inProgress': 'In progress',
  'workspaceCommon.annotationConfig.cancelEditMode': 'Cancel',
  'workspaceCommon.annotationConfig.addEvidenceButton': 'Add evidence',
  'workspaceCommon.annotationConfig.addingEvidenceButton': 'Adding evidence',
  'workspaceCommon.annotationConfig.saveAnnotationButton': 'Save',
  'workspaceCommon.annotationConfig.evidenceNotRequiredWhenPresent':
    'Evidence not required when Present = no',
  'workspaceCommon.annotationConfig.evidenceRequiredWhenPresent':
    'Evidence is required when Present = Yes',

  // Note section (shared between annotation and supervisor)
  'workspaceCommon.noteSection.addEvidenceMode': 'Evidence mode',
  'workspaceCommon.noteSection.addEvidenceMode.description':
    'Add evidence for concept {conceptName} (Annotation #{annotationNumber})',
  'workspaceCommon.noteSection.selectedSnippetCount.singular': '{snippetCount} snippet selected',
  'workspaceCommon.noteSection.selectedSnippetCount.plural': '{snippetCount} snippets selected',
  'workspaceCommon.noteSection.addEvidenceDoneButton': 'Done',
  'workspaceCommon.noteSection.attachButton': 'Add evidence',
  'workspaceCommon.noteSection.cancelAttachButton': 'Cancel',

  // Saved annotation card (shared between annotation and supervisor)
  'workspaceCommon.savedAnnotationCard.showEvidenceButton': 'Show evidence',
  'workspaceCommon.savedAnnotationCard.attribute.yes': 'Yes',
  'workspaceCommon.savedAnnotationCard.attribute.no': 'No',
  'workspaceCommon.savedAnnotationCard.attribute.unknown': 'Unknown',

  // Confirm delete modal
  'workspaceCommon.confirmDeleteModal.title': 'Confirm delete',
  'workspaceCommon.confirmDeleteModal.warning.title': 'Confirm delete',
  'workspaceCommon.confirmDeleteModal.warning': 'This action cannot be undone.',
  'workspaceCommon.confirmDeleteModal.description.prefix': 'This action will permanently delete',
  'workspaceCommon.confirmDeleteModal.loadingMessage': 'Deleting...',
  'workspaceCommon.confirmDeleteModal.confirmButton': 'Delete',
  'workspaceCommon.confirmDeleteModal.cancelButton': 'Cancel',

  // Confirm reject modal
  'workspaceCommon.confirmRejectModal.title': 'Confirm reject',
  'workspaceCommon.confirmRejectModal.warning.title': 'Confirm reject',
  'workspaceCommon.confirmRejectModal.warning': 'This action cannot be undone.',
  'workspaceCommon.confirmRejectModal.description.prefix': 'This action will permanently reject',
  'workspaceCommon.confirmRejectModal.loadingMessage': 'Rejecting...',
  'workspaceCommon.confirmRejectModal.confirmButton': 'Reject',
  'workspaceCommon.confirmRejectModal.cancelButton': 'Cancel',
};
